import React from "react";
import "./Calculate.css";
import CB from "../Calculate/CB";
import TPT from "../Calculate/TPT";
import HLB from "../Calculate/HLB";


export const Calculate = ({ page }) => {

  return (
    <div id="services" className="sv_services">
      {page === 'CB' && <CB />}
      {page === 'TPT' && <TPT />}
      {page === 'HLB' && <HLB />}
    </div>
  );
};
